import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { couponCodeAtom } from "src/atoms";
import { useApiError } from "src/hooks/useApiError";
import { getInicisData } from "src/service/pay";
import { IGetInicisDataRes } from "src/service/types/pay.type";

interface IPriceCheckerProps {
  priceType: string; // 요금제
  userPerPrice: number; // 사용자당 월 요금
  userPerPriceYear: number; // 사용자당 연 요금
  setInicisData: React.Dispatch<
    React.SetStateAction<IGetInicisDataRes | undefined>
  >; // INICIS 결제 데이터
  // payApply: ({
  //   orderID,
  //   subscriptionID,
  // }: {
  //   orderID: string;
  //   subscriptionID: string;
  // }) => void;
}

// InicisData 세팅
const InicisDataChecker = ({
  priceType,
  userPerPrice,
  userPerPriceYear,
  setInicisData,
}: IPriceCheckerProps) => {
  const { watch } = useFormContext();
  const payTerm = watch("payTerm");
  const licenseCount = watch("licenseCount");
  const [couponCodeInfo, setCouponCodeInfo] = useRecoilState(couponCodeAtom);
  const { handleError } = useApiError();
  const { data } = useQuery(
    [
      "getInicisData",
      payTerm,
      licenseCount,
      userPerPrice,
      userPerPriceYear,
      priceType,
      couponCodeInfo,
    ],
    async () => {
      if (couponCodeInfo) {
        return await getInicisData({
          price:
            payTerm === "year"
              ? userPerPriceYear * 12 * licenseCount
              : userPerPrice * licenseCount,
          couponCode: couponCodeInfo.couponCode,
        });
      } else {
        return await getInicisData({
          price:
            payTerm === "year"
              ? userPerPriceYear * 12 * licenseCount
              : userPerPrice * licenseCount,
        });
      }
    },
    {
      enabled: !!(
        payTerm &&
        licenseCount &&
        userPerPrice &&
        userPerPriceYear &&
        priceType
      ),
      // refetchOnMount: true,
      onError: handleError,
    }
  );

  // 서명 데이터는 "현재 폼 값에 대응하는 조회 결과"만 사용한다.
  // 폼 값이 바뀌면 쿼리 키가 달라져 data가 undefined가 되고, 재조회가 끝날 때까지
  // 결제가 자동으로 차단된다. (화면 금액 ≠ 실제 결제 금액 방지)
  useEffect(() => {
    setInicisData(data);
  }, [data, setInicisData]);
  // async function init() {
  //   if(couponCodeInfo) {

  //   }else {

  //     await getInicisData({
  //       price:
  //         payTerm === "year"
  //           ? userPerPriceYear * 12 * licenseCount
  //           : userPerPrice * licenseCount,
  //     })
  //       .then((inicisData) => {
  //         setInicisData(inicisData);
  //         // 아래 3줄 확인할것
  //         // 주문정보 서버에 저장 -> 이후 해당 내용을 기반으로 결제 진행

  //         // payApply({
  //         //   orderID: inicisData?.oid,
  //         //   subscriptionID: "Inicis",
  //         // });
  //         return;
  //       })
  //       .catch((e) => {
  //         console.log("getInicisData err", e);
  //         return;
  //       });
  //   }
  // }
  // useEffect(() => {
  //   if (
  //     payTerm &&
  //     licenseCount &&
  //     userPerPrice &&
  //     userPerPriceYear &&
  //     priceType
  //   ) {
  //     init();
  //   }
  // }, [licenseCount, payTerm, userPerPrice, userPerPriceYear, priceType, couponCodeInfo]);
  return null;
};

export default InicisDataChecker;
